<template>
    <Head titulo="Historia de Santiago" />
    <div class="hero-imgs hero-imgs-encabezado">
      <div class="container">
        <div class="row align-items-md-center">
          <div class="col-md-6">
            <h1 class="hero-imgs__encabezado">Historia de Santiago</h1>
          </div>
          <div class="col-md-6">
            <div class="hero-imgs__img img-der">
              <img loading="lazy" width="450" height="358" src="/img/hero-turismo-lugares-interes.png?v=1" alt="Santiago Lugares de interés">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contenido-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="breadcrumb-block-wrapper">
              <ul class="breadcrumb-block">
                <li class="breadcrumb-block__item">
                  <a href="/turismo" class="breadcrumb-block__section">Turismo</a>
                </li>
                <li class="breadcrumb-block__item active">
                  <span class="breadcrumb-block__section">Historia de Santiago</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="bloque-general bloque-info-img">
        <div class="container">
          <div class="row flex-md-row-reverse">
            <div class="col-md-7">
              <h2 class="bloque-encabezado">Un pueblo lleno de historia</h2>
              <div class="bloque-descripcion">
                <p>Desde la fundaci&oacute;n de la ciudad de Monterrey en 1596 por Diego de Montemayor y 12 familias que vinieron de Saltillo, las tierras que hoy ocupa el municipio de Santiago ya se conoc&iacute;an con el nombre de &laquo;Cayucuapa&raquo;. Pero los colonizadores de la ciudad utilizaban estos lugares para agostar sus ganados y por esta raz&oacute;n, ellos le llamaban Potrero Grande. Posteriormente Guaxuco y Colmillo, indios guachichiles, dominaron estos lugares y atacaron casi todas las primeras poblaciones del Nuevo Reino de Le&oacute;n.</p>

<p>Guaxuco significa &laquo;lugar de abundante agua&raquo;. Mientras que el Guaxuco sal&iacute;a a hacer sus tropel&iacute;as por el ca&ntilde;&oacute;n de los Lampazos, hoy La Nogalera o Potrero de Serna; Colmillo lo hac&iacute;a por la desembocadura del r&iacute;o Ramos. Despu&eacute;s en 1625 los mismos naturales mataron al Guaxuco cerca del r&iacute;o Pil&oacute;n, as&iacute; fue disminuyendo la belicosidad en estas tierras. Tras estos acontecimientos los mismos colonizadores le llamaron a estos lugares &laquo;del Guaxuco&raquo;. Adem&aacute;s existieron una serie de variantes ortogr&aacute;ficas de las denominaciones &laquo;Cayucuapa&raquo; y &laquo;Guaxuco&raquo;.</p>

<p>El primer asentamiento inici&oacute; el 20 de marzo de 1646 cuando el gobernador Mart&iacute;n de Zavala dio a Diego Rodr&iacute;guez de Montemayor una merced de tierra en estos lugares. fund&oacute; una hacienda que le llam&oacute; San Miguel, a orillas del arroyo Las Cristalinas. Para el a&ntilde;o de 1700, ya exist&iacute;an 12 grandes haciendas, fundadas por los hijos de Diego Rodr&iacute;guez de Montemayor, conservando algunas de estas comunidades su nombre original. Las primeras haciendas fueron: San Javier, San Francisco, Labor de San Diego en El Cercado, Labor de Gertrudis, Labor de Dorotea, La Huasteca, San Pedro de Salazares, Santa Rosal&iacute;a, Los Prieto, Los Rodr&iacute;guez, San Nicol&aacute;s del Cercado y San Miguel o &laquo;Hacienda Vieja&raquo;.</p>

<p>Para el a&ntilde;o de 1712 ya contaba con m&aacute;s de 15 haciendas y se eleva a categor&iacute;a de Valle con el nombre de &laquo;Valle de Santiago del Guaxuco&raquo;, en esta categor&iacute;a como Valle, se instaura el primer ayuntamiento, siendo Don Gregorio de Trevi&ntilde;o de Renter&iacute;a el primer alcalde y en 6 ocasiones m&aacute;s.</p>

<p>La palabra Santiago viene de la fusi&oacute;n de las palabras &laquo;San&raquo;, ap&oacute;cope de santo y del nombre &laquo;Jacobo&raquo; que se deriva del hebreo y que significa &laquo;El protegido de Dios&raquo;.</p>

<p>El nombre de Santiago es en honor al Ap&oacute;stol Santiago, Santo Patrono de Espa&ntilde;a y de uso muy com&uacute;n en M&eacute;xico a partir de la conquista, ya que gran parte de los colonizadores eran caballeros de La Orden religiosa-militar de Santiago.</p>

<p>Luego, en 1745 este Valle que ya contaba con una poblaci&oacute;n de m&aacute;s de 700 habitantes; previa solicitud del vecindario, el obispado de Guadalajara autoriz&oacute; una parroquia con advocaci&oacute;n a Santiago Ap&oacute;stol, patrono del Huajuco desde 1712, y as&iacute; lleg&oacute; la consolidaci&oacute;n del nombre.</p>

<p>En 1825, cuando M&eacute;xico daba sus primeros pasos como naci&oacute;n independiente, la Constituci&oacute;n Pol&iacute;tica del reci&eacute;n formado Estado Libre y Soberano de Nuevo Le&oacute;n, lo sanciona como &laquo;Distrito Municipal del Guaxuco&raquo;. Ya el 21 de marzo de 1831, su cabecera municipal es elevada de categor&iacute;a otorg&aacute;ndole el t&iacute;tulo de &laquo;Villa de Santiago&raquo;, mismo que est&aacute; vigente hasta nuestros d&iacute;as.</p>

              </div>
            </div>
            <div class="col-md-5">
              <div class="bloque-info-img__img">
                <img loading="lazy" width="278" height="245" src="/img/test-lugares-interes-1.png" alt="Atractivos turísticos de Santiago">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bloque-color-img">
      <div class="bloque-color-img__info-wrapper">
        <div class="bloque-color-img__info">
          <h3 class="bloque-encabezado">El municipio turístico por excelencia</h3>
          <div class="contenido-administrable">
            <p>Santiago, Nuevo Le&oacute;n, es sin duda, el municipio m&aacute;s seductor de la entidad, por su inconmensurable belleza natural, sus diversos atractivos tur&iacute;sticos, por el encanto de su arquitectura colonial de su cabecera municipal y, sobre todo, por la calidez de sus habitantes, quienes le dan vida y reconocen con orgullo representar la memoria e identidad del santiaguense.</p>

            <p>Sus monumentos, casonas, y casas de sobria arquitectura norestense, aunado al sabor provinciano de sus calles, plazas y plazuelas, formaron en m&aacute;s de dos siglos el actual Centro Hist&oacute;rico.</p>          </div>
        </div>
      </div>
      <div class="bloque-color-img__img" style="background-image: url('/img/test-historia-1.jpg')"></div>
    </div>
    <div class="bloque-general bloque-img-ancho-completo">
      <div class="container">
        <div class="row align-items-md-center flex-md-row-reverse">
          <div class="col-md-6 col-lg-5 offset-lg-1">
            <div class="contenido-administrable">
                <p>El desarrollo de nuestro municipio ha estado estrechamente vinculado con el agua, es imposible no considerar al recurso h&iacute;drico como un indicador dentro de la planificaci&oacute;n territorial, debido a sus considerables aportes al avance socioecon&oacute;mico. El aumento de productos tur&iacute;sticos van de la mano con los recursos h&iacute;dricos; la generaci&oacute;n de actividades recreativas en La Cascada Cola de Caballo, la Presa Rodrigo G&oacute;mez (La Boca), r&iacute;os, arroyos y acequias, as&iacute; como el turismo de aventura en Matacanes, El Chipit&iacute;n e Hidrofobia tienen por efecto el crecimiento econ&oacute;mico y el desarrollo social de la regi&oacute;n, se les reconoce como agentes contribuyentes en el progreso de las comunidades. En este sentido, el turismo es un elemento de referencia en la identidad cultural santiaguense.</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="bloque-img-ancho-completo__img">
              <img loading="lazy" width="540" height="551" src="/img/test-historia-2.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Head from '../../Shared/Head.vue';
export default {
    components: { Head }
}
</script>
<style scoped>

</style>
